import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ExportIcon = props => (
  <SvgIcon {...props} viewBox="0 0 36 36">
    <path
      d="M17 22C17 21.7348 17.1054 21.4804 17.2929 21.2929C17.4804 21.1054 17.7348 21 18 21H26V6C26 5.46957 25.7893 4.96086 25.4142 4.58579C25.0391 4.21071 24.5304 4 24 4H10.87L4 10.86V30C4 30.5304 4.21071 31.0391 4.58579 31.4142C4.96086 31.7893 5.46957 32 6 32H24C24.5304 32 25.0391 31.7893 25.4142 31.4142C25.7893 31.0391 26 30.5304 26 30V23H18C17.7348 23 17.4804 22.8946 17.2929 22.7071C17.1054 22.5196 17 22.2652 17 22ZM12 12H6V11.68L11.69 6H12V12Z"
      id="Shape"
    />
    <path
      d="M29.32 16.35C29.1287 16.1861 28.8826 16.1005 28.6309 16.1102C28.3793 16.12 28.1405 16.2243 27.9624 16.4024C27.7843 16.5805 27.68 16.8192 27.6703 17.0709C27.6606 17.3226 27.7462 17.5687 27.91 17.76L31.16 21H26V23H31.19L27.91 26.28C27.8053 26.3696 27.7203 26.4799 27.6603 26.604C27.6003 26.728 27.5665 26.8632 27.5612 27.0009C27.5559 27.1386 27.5791 27.276 27.6294 27.4043C27.6796 27.5326 27.7559 27.6491 27.8533 27.7466C27.9508 27.8441 28.0674 27.9203 28.1957 27.9706C28.324 28.0209 28.4613 28.0441 28.5991 28.0388C28.7368 28.0334 28.8719 27.9997 28.996 27.9397C29.12 27.8797 29.2304 27.7946 29.32 27.69L35 22L29.32 16.35Z"
      id="Shape"
    />
  </SvgIcon>
);

export default ExportIcon;
